import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useState } from "react";

import { PublicSvgIcon } from "~/components/public_svg_icon";

interface StripeFundsReleaseStatusProps {
  id: string;
  label: string;
  type: string;
}

export function StripeFundsReleaseStatus({
  id,
  label,
  type,
}: StripeFundsReleaseStatusProps) {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  return (
    <Stack>
      <Accordion expanded={isExpanded} onChange={(_, ex) => setIsExpanded(ex)}>
        <AccordionSummary
          expandIcon={
            <PublicSvgIcon name={isExpanded ? "expand_less" : "expand_more"} />
          }
          sx={{
            backgroundColor: "blackStates._states.hover",
          }}
        >
          <Typography variant="body1">{label}</Typography>
        </AccordionSummary>

        <AccordionDetails
          sx={{
            backgroundColor: "blackStates._states.hover",
          }}
        >
          <Stack flexDirection="column" spacing={3}>
            <Stack spacing={2}>
              <Stack>
                <Typography variant="body2DashedDivider" fontWeight="bold">
                  {type[0].toUpperCase() + type.slice(1)}
                </Typography>
                <Stack flexDirection="row" alignItems="center">
                  <Typography
                    variant="captionWithBackground"
                    sx={{
                      backgroundColor: "background.default",
                      width: "min-content",
                    }}
                  >
                    {id}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </AccordionDetails>
      </Accordion>
    </Stack>
  );
}
